// 3rd Party
import Analytics from '@opencare/analytics';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { SPECIALTY } from 'common/constants';
import { ColoredButton, Div } from 'common/styles/oc-styled-components';
import { selectDataUser } from 'connect/selectors';

import { useFunnelStorage } from '../../../funnel/storage/Storage';
import { selectDataClinic } from '../../connect/selectors';
import ClinicHoursList from '../ClinicHoursList/ClinicHoursList';

// Other

import { RequestAppointmentViewWrapper, Title } from './styled-components';

const analytics = new Analytics();

// Component
const RequestAppointmentView = ({
  hours,
  onRequestAppointment,
  title,
  disabledCta,
}) => {
  const funnelStorage = useFunnelStorage();
  const clinic = useSelector(selectDataClinic);
  const user = useSelector(selectDataUser);

  const clinicIsDental = clinic.primarySpecialty?.id === SPECIALTY.dentist;

  const handleRequestAppointment = () => {
    onRequestAppointment();
    analytics.trackClick({
      pageType: analytics.pageTypes.PRACTICE_PROFILE,
      pageName: clinic.name,
      name: 'non-instant-book',
      section: clinic.name,
      userId: user?.id,
      practiceId: clinic.id,
      partnerId: user?.partner?.id,
      funnelConfigId: funnelStorage?.config?.id,
    });
  };

  return (
    <>
      {hours
        && (
          <RequestAppointmentViewWrapper>
            <Title>{title}</Title>
            <Div padding="8px 12px">
              <ClinicHoursList hours={hours} />
            </Div>
          </RequestAppointmentViewWrapper>
        )}

      {clinicIsDental
        && (
          <ColoredButton
            size="large"
            shape="round"
            background={BRAND_COLORS.darkGreen}
            color={BRAND_COLORS.white}
            block
            onClick={handleRequestAppointment}
            disabled={disabledCta}
            data-testid="request-btn"
            bold="true"
          >
            Request Appointment
          </ColoredButton>
        )}
    </>
  );
};

RequestAppointmentView.propTypes = {
  hours: PropTypes.array,
  onRequestAppointment: PropTypes.func,
  title: PropTypes.string,
  disabledCta: PropTypes.bool.isRequired,
};

export default RequestAppointmentView;
